import CsatByDeviceTagChart from './CsatByDeviceTagChart';
export default CsatByDeviceTagChart;



// WEBPACK FOOTER //
// ./src/components/CsatByDeviceTagChart/index.js